export const apiKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDRGRDgwNDEwNTVjM0E1NjgyM2NBMDk4NDExZjkzNGU3NTQ0RDI2YTkiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTYzMzYzOTYzNDcwNSwibmFtZSI6ImNvbW11bml0eSBnYXJkZW4ifQ.4vcBo0Irc2tA65oi6y4iyvOHor18zET0mqtbbe-1-sY'
